"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const react_1 = tslib_1.__importDefault(require("react"));
const defaultProps = {
    offset: 0,
};
class InfiniteLoading extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.handleScroll = () => {
            const { onLoadMore, shouldLoadMore, offset } = this.props;
            if (shouldLoadMore &&
                window.innerHeight + window.scrollY >= document.body.offsetHeight - offset) {
                if (onLoadMore) {
                    onLoadMore();
                }
            }
        };
        this.handleScroll = lodash_1.default.debounce(this.handleScroll, 300);
    }
    componentDidMount() {
        document.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
    }
    render() {
        const { children } = this.props;
        if (!children) {
            return null;
        }
        return children;
    }
}
exports.default = InfiniteLoading;
InfiniteLoading.defaultProps = defaultProps;
